/* Fliteboard AU treatment v1 | 23 October 2026
 * Keep shared modals available; initialise configurator behaviour only where
 * its variant form exists. Optional selectors may be absent on some models.
 */
var productPathArray = window.location.pathname.split("/");
var productHandle = productPathArray[productPathArray.length - 1].split("?")[0];
if (document.URL.includes("preview")) {
  var productJsonPath = document.URL + "&view=fa-json";
} else {
  var productJsonPath =
    window.Shopify.routes.root + "products/" + productHandle + "?view=fa-json";
}

function groupBy(arr, attr) {
  var result = arr.reduce((x, y) => {
    (x[y[attr]] = x[y[attr]] || []).push(y);
    return x;
  }, {});
  return result;
}

function mapOptions(arr, _prop) {
  var results = arr.map((variant) => {
    return variant[_prop];
  });
  console.log(
    "only unique filtered results " + _prop,
    results.filter(onlyUnique)
  );
  return results.filter(onlyUnique);
}

function selectSelectedOrFirstAvailableOptions(arr) {
  if (!Array.isArray(arr) || arr.length === 0) return;
  // CHECK WHAT OPTIONS ARE AVAILABLE
  var _options = [
    // { name: "efoil", id: "0" },
    { name: "propulsion", id: "1" },
    { name: "wing_set", id: "2" },
  ];
  _options.map((_opt) => {
    hideUnavailableOptions(arr, _opt);
    // hideUnavailableEnhancements(arr, _opt);
    var varSelection = $(`input[name=option-${_opt.id}]:checked`).val();
    if (mapOptions(arr, _opt.name).includes(varSelection)) {
      // console.log('Return False Selects');
      console.log("opname", _opt.name);
      if (_opt.name == "wing_set") {
        var selectedWingset = document.querySelector("input[name=option-2]:checked");
        var selectedWingsetItem = selectedWingset && selectedWingset.closest("li");
        var selectWingset = selectedWingsetItem && selectedWingsetItem.classList;
        // if (selectWingset) {
        console.log(selectWingset);
        if (selectWingset && selectWingset.contains("notAvailable")) {
          console.log("selectWingset", selectWingset);
          var newSelection = document.querySelector(
            `li.isAvailable input[name=option-2]`
          );
          if(newSelection) {
            newSelection.click();
          }
        }
        // }
      }
      updatePrice();
      return false;
    } else {
      // console.log('map Options', mapOptions(arr, _opt.name));
      console.log(
        "Input",
        `ul li.isAvailable input[value="${mapOptions(arr, _opt.name)[0]}"]`
      );
      return $(
        `ul li.isAvailable input[value="${mapOptions(arr, _opt.name)[0]}"]`
      ).click();
    }
  });

  // Show and hide toggle - PROPULSION
  $('ul.drive li').removeClass("hide");
  // $('ul.drive li.isAvailable').slice(3).addClass("hide");
  // $('ul.drive li.isAvailable').hide().slice(0, 3).show();
  // if ($('ul.drive li.isAvailable').length <= 3) {
  //   $('.toggle.drive').hide();
  // } else {
  //   $('.toggle.drive').show();
  // }

  // Show and hide toggle - WING SET
  $('ul.wing_set li').removeClass("hide");
  // $('ul.wing_set li.isAvailable').slice(3).addClass("hide");
  // $('ul.wing_set li.isAvailable').hide().slice(0, 3).show();
  // if ($('ul.wing_set li.isAvailable').length <= 3) {
  //   $('.toggle.wing_set').hide();
  // } else {
  //   $('.toggle.wing_set').show();
  // }

}

function belongsTo(arr, variant, prop) {
  return mapOptions(arr, prop).includes(variant[prop]);
}

function setUnavailable(el) {
  el.parent().addClass("notAvailable").removeClass("isAvailable");
}

function setAvailable(el) {
  el.parent().addClass("isAvailable").removeClass("notAvailable");
}

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

function optByInput(_opt) {
  return $(`input[name="option-${_opt.id}"]`);
}

function optByValue(variant, _opt) {
  return $(`input[value="${variant[_opt.name]}"]`);
}

function hideUnavailableOptions(arr, _opt) {
  var _optProperty = _opt.name;
  // Hide all options (then reshow)
  setUnavailable(optByInput(_opt));
  var selectPropulsion = $("input[name=option-1]:checked").val();
  var arrFilter = arr.filter((variant) => {
    if (_opt.name == "wing_set") {
      return variant.propulsion == selectPropulsion;
    } else {
      return true;
    }
  });

  arrFilter.map((variant) => {
    if (belongsTo(arrFilter, variant, _opt.name)) {
      setAvailable(optByValue(variant, _opt));
    }
  });
}

function hideUnavailableEnhancements(arr, _opt) {
  var _optProperty = _opt.name;
  $(
    `#enhanceBlockModal--${_opt.name.downcase}s-expand .slider__slide`
  ).addClass("notAvailable");
  arr.map((variant) => {
    if (belongsTo(arr, variant, _opt.name)) {
      $(
        `#enhanceBlockModal--${
          _opt.name.downcase
        }s-expand .slider__slide:contains('${variant[_opt.name]}')`
      ).removeClass("notAvailable");
    }
  });
}

async function getProductJson(selectedOption, optionName) {
  if (!document.querySelector('.variant-select') || selectedOption == null || selectedOption === '') {
    return;
  }
  var productJson = await fetch(productJsonPath)
    .then((response) => response.json())
    .then((data) => {
      return selectSelectedOrFirstAvailableOptions(
        groupBy(data["productData"], optionName)[selectedOption]
      );
    });
  return productJson;
}

document.addEventListener("variant:changed", function (event) {
  var optionIds = [
    { name: "efoil", id: "0" },
    { name: "propulsion", id: "1" },
    { name: "wing_set", id: "2" },
  ];
  var selectEfoil = $("input[name=option-0]:checked").val();
  var selectPropulsion = $("input[name=option-1]:checked").val();
  var selectWingset = $("input[name=option-2]:checked").val();
  getProductJson(selectEfoil, "efoil");
});

var selectEfoil = $("input[name=option-0]:checked").val();
var selectPropulsion = $("input[name=option-1]:checked").val();
var selectWingset = $("input[name=option-2]:checked").val();

// Initial selection runs after the page markup is ready.

function calculateCombinedLeadTime(boardLeadTime, batteryLeadTime, controllerLeadTime, chargerLeadTime){
      /*
        if biggest number is 1 > Ships in 1 week
        If biggest number is 0 > Next day shipping
        If biggest number is between 2 and 14 > Ships in {insert number} weeks
        If biggest number is 15 > Contact us to confirm shipping time
      */

      var validLeadTimes = [];
      if (boardLeadTime !== "" && boardLeadTime !== null && boardLeadTime !== undefined) {
        validLeadTimes.push(Number(boardLeadTime));
      }
      if (batteryLeadTime !== "" && batteryLeadTime !== null && batteryLeadTime !== undefined) {
        validLeadTimes.push(Number(batteryLeadTime));
      }
      if (controllerLeadTime !== "" && controllerLeadTime !== null && controllerLeadTime !== undefined) {
        validLeadTimes.push(Number(controllerLeadTime));
      }
      if (chargerLeadTime !== "" && chargerLeadTime !== null && chargerLeadTime !== undefined) {
        validLeadTimes.push(Number(chargerLeadTime));
      }

      var leadTimeText = "";

      if (validLeadTimes.length > 0) {
        var combinedLeadTime = Math.max(...validLeadTimes);
        if(combinedLeadTime == 0){
          leadTimeText = (window.leadTimeTranslations || {}).next_day_shipping;
        } else if(combinedLeadTime == 1){
          leadTimeText = (window.leadTimeTranslations || {}).ships_1_week;
        } else if(combinedLeadTime > 14){
          leadTimeText = (window.leadTimeTranslations || {}).contact_us;
        } else if (combinedLeadTime > 1) {
          leadTimeText = ((window.leadTimeTranslations || {}).ships_weeks).replace("{{ weeks }}", combinedLeadTime);
        } else {
          leadTimeText = (window.leadTimeTranslations || {}).contact_us_plural;
        }
      } else {
        leadTimeText = (window.leadTimeTranslations || {}).contact_us;
      }

      $("#OrderSummary.flite-air .OrderSummaryTitle p#combined-lead-time").html(leadTimeText);
      $("#configurator-footer.marc-newson .footer-product-meta p#combined-lead-time").html(leadTimeText);

    }

function updatePrice() {
  const variantSelect = document.querySelector('.variant-select');
  const selectedVariant = variantSelect && variantSelect.querySelector('option:checked');
  if (!variantSelect || !selectedVariant) return;
  const countryCode = variantSelect.getAttribute("data-country");
  const currencyCode = variantSelect.getAttribute("data-currency");
  const price = selectedVariant.getAttribute("data-variant-price").replace(",", "") * 100;
  const comparePrice = selectedVariant.getAttribute("data-variant-compare-price").replace(",", "") * 100;
  const leadTime = selectedVariant.getAttribute("data-leadtimeweeks");
  const leadTimeText = selectedVariant.getAttribute("data-leadtimetext");

  $(".SummaryBlock#summaryBoard").attr("data-lead-time", leadTime);
  $(".SummaryBlock#summaryBoard").attr("data-lead-time-text", leadTimeText);
  /** LEAD TIME COMBOBULATOR **/

  var selectedConfigLeadTime = leadTime;
  var selectedConfigLeadTimeText = leadTimeText;
  var selectedBatteryLeadTime = $(".HorizontalList.flitecell.option input:checked").data("option-lead-time");
  var selectedChargerLeadTime = $("#chargerSelector input:checked").data("option-lead-time");
  var selectedControllerLeadTime = $("#controllerSelector input:checked").data("option-lead-time");

  if (selectedConfigLeadTimeText && selectedConfigLeadTimeText !== "" && selectedConfigLeadTimeText !== "null") {
    $("#OrderSummary.flite-air .OrderSummaryTitle p#combined-lead-time").html(selectedConfigLeadTimeText);
    $("#configurator-footer.marc-newson .footer-product-meta p#combined-lead-time").html(selectedConfigLeadTimeText);
  } else {
    calculateCombinedLeadTime(selectedConfigLeadTime, selectedBatteryLeadTime, selectedControllerLeadTime, selectedChargerLeadTime);
  }

  let selectedVariants = $(".addOn");
  var selectedFormData = $.map(selectedVariants, function (obj) {
    var rawPrice = obj.getAttribute("data-price");
    return rawPrice ? rawPrice.replace(",", "") : "0.00";
  });

  var priceWithAddOns = parseInt(price, 10) + selectedFormData.reduce((partialSum, a) => parseFloat(partialSum, 10) + parseFloat(a, 10), 0) * 100;
  var comparePriceWithAddOns = parseInt(comparePrice, 10) + selectedFormData.reduce((partialSum, a) => parseFloat(partialSum, 10) + parseFloat(a, 10), 0) * 100;
  var currency = new Intl.NumberFormat("en-" + countryCode, { style: "currency", currency: currencyCode, minimumFractionDigits: 0, maximumFractionDigits: 0 });

  $(".configuratorPrice, .OrderSummaryPrice .configuratorPrice").html(currency.format(priceWithAddOns / 100));
  if (comparePrice > 0.0) {
    $(".configuratorComparePrice, .OrderSummaryPrice .configuratorComparePrice").html(currency.format(comparePriceWithAddOns / 100));
  } else {
    $(".configuratorComparePrice, .OrderSummaryPrice .configuratorComparePrice").html("");
  }
  $('.ZipText .ProductMeta__MonthlyPrice').html(currency.format(priceWithAddOns / 100 / 12));
  removeBlurs();
}

window.updatePrice = updatePrice;

document.addEventListener('fa:prices-set', function(event) {
  updatePrice();
});

function removeBlurs() {
  if (typeof window.faPricesReady === 'undefined' || !window.faPricesReady) {
    return;
  }

  let blurred = document.getElementsByClassName("blur");
  if(blurred.length > 0) {
    blurred[0].classList.remove("blur");
  }
}

// updatePrice();
//removeBlurs();
function initializeConfiguratorSelectors() {
  if (!document.querySelector('.variant-select')) return;
  getProductJson($('input[name=option-0]:checked').val(), 'efoil');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeConfiguratorSelectors, { once: true });
} else {
  initializeConfiguratorSelectors();
}